export default "__VITE_ASSET__BKTGQ6bY__"